// extracted by mini-css-extract-plugin
export default {"infoContainer":"style_infoContainer__TtyDh"};